import { Component } from '@angular/core';

@Component({
  selector: 'workflow-admin-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'demo';
}
